import { render } from "./add-goods-category-dialog.vue?vue&type=template&id=7f846f1e&scoped=true"
import script from "./add-goods-category-dialog.vue?vue&type=script&lang=js"
export * from "./add-goods-category-dialog.vue?vue&type=script&lang=js"

import "./add-goods-category-dialog.vue?vue&type=style&index=0&id=7f846f1e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f846f1e"]])

export default __exports__